// Finish Filter with localStorage
document.addEventListener('DOMContentLoaded', function() {
  const finishRadios = document.querySelectorAll('input[name="finish_filter"]');
  
  if (finishRadios.length === 0) return;
  
  // Load saved selection from localStorage
  const savedFinish = localStorage.getItem('finish_filter');
  if (savedFinish) {
    const radioToCheck = document.querySelector(`input[name="finish_filter"][value="${savedFinish}"]`);
    if (radioToCheck) {
      radioToCheck.checked = true;
    }
  }
  
  // Save selection to localStorage when changed
  finishRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      if (this.checked) {
        localStorage.setItem('finish_filter', this.value);
      }
    });
  });
});
